import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import svg6 from "../../assets/svg/svg6.svg";

const data = [
  { name: "Monday", Present: 4000, Absent: 2400, amt: 2400 },
  { name: "Tuesday", Present: 3000, Absent: 1398, amt: 2210 },
  { name: "Wednesday", Present: 2000, Absent: 9800, amt: 2290 },
  { name: "Thursday", Present: 2780, Absent: 3908, amt: 2000 },
  { name: "Friday", Present: 1890, Absent: 4800, amt: 2181 }, 
];

const AttendanceRate = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleMoreDetails = () => {
    navigate("/attendance-entries");
  };
  return (
    <div className="bg-white rounded-[10px] lg:p-10 p-2 w-full lg:h-[600px] h-auto">
      <div className=" flex items-center justify-between">
        <div className="product_request_title ">Attendance Rate</div>
        <div
          className="flex items-center gap-x-3 cursor-pointer"
          onClick={handleMoreDetails}
        >
          More details <img src={svg6} alt="svg6" />
        </div>
      </div>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          width={500}
          height={300}
          data={data}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line
            type="monotone"
            dataKey="Absent"
            stroke="#8884d8"
            activeDot={{ r: 8 }}
          />
          <Line type="monotone" dataKey="Present" stroke="#82ca9d" />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default AttendanceRate;
